import { Injectable } from "@angular/core";
import type { FormlyFieldConfig } from "@ngx-formly/core";
import { sumBy } from "lodash";
import { debounceTime, distinctUntilChanged, map, merge, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class FormlyUnsavedChangesService {
  track(field: FormlyFieldConfig): Observable<number> {
    return merge(field.options.fieldChanges, field.form.statusChanges).pipe(
      debounceTime(100),
      map(() => this.count(field)),
      distinctUntilChanged()
    );
  }

  private count(field: FormlyFieldConfig): number {
    return field.fieldGroup?.length ? sumBy(field.fieldGroup, (x) => this.count(x)) : this.hasChanges(field) ? 1 : 0;
  }

  private hasChanges(field: FormlyFieldConfig): boolean {
    return !field.hide && field.formControl?.dirty;
  }
}
